import { Directive, HostListener } from '@angular/core';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: 'input[type=phoneNumber]',
    standalone: false
})
export class PhoneNumberDirective {

  constructor() { }
  @HostListener('input', ['$event'])
  oninput(event) {
    const pattern = /[0-9\+\(\)\-\  ]/;
    const inputChar = event.target.value;

    if (!pattern.test(inputChar)) {
      event.target.value = '';
      event.preventDefault();
    }
  }
  @HostListener('keydown', ['$event'])
  keyPress(event: KeyboardEvent) {
    const pattern = /[0-9\+\(\)\-\  ]/;

    const inputChar = event.key;
    if (event.keyCode !== 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
    if (event.keyCode === 13) {
      event.preventDefault();

    }
  }
}

